module.exports = __webpack_public_path__ + "static/9-e5f040400ef2af133e444e7a71aa95e2.jpg";